<template>
  <section class="favorite-connect-header">
    <div class="favorite-connect-header--top">
      <div class="favorite-connect-header--text">
        <div class="favorite-connect-header--badge">{{ badgeText }}</div>
        <h1>Favorit Saya</h1>
        <p>{{ description }}</p>
      </div>
      <button type="button" class="btn back--button" @click="goBack">
        <v-icon class="back--icon">mdi-arrow-left</v-icon>
        <span>Kembali</span>
      </button>
    </div>

    <button-switch-owner-connect variant="favorite" :show-favorite-button="false" />
  </section>
</template>

<script>
import ButtonSwitchOwnerConnect from '@/components/search-listing/button-switch-owner-connect.vue';

export default {
  name: 'favorite-connect-header',
  components: {
    ButtonSwitchOwnerConnect,
  },
  props: {
    type: {
      default: 'owner',
    },
  },
  computed: {
    isProject() {
      return this.type === 'project';
    },
    badgeText() {
      return this.isProject ? 'Project Connect' : 'Owner Connect';
    },
    description() {
      if (this.isProject) {
        return 'Simpan project yang menarik bagi Anda dan akses kembali dengan mudah untuk menjelajahi peluang bisnis yang lebih besar.';
      }
      return 'Simpan pemilik properti yang menarik bagi Anda dan akses kembali dengan mudah saat siap membangun koneksi atau mencari peluang listing baru.';
    },
    backRouteName() {
      return this.isProject ? 'project-connect' : 'owner-connect';
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: this.backRouteName });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.favorite-connect-header {
  padding: 10px 0 18px;
}

.favorite-connect-header--top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
  padding: 22px 24px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
  overflow: hidden;

  @media #{$phones, $tablets} {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 18px;
  }
}

.favorite-connect-header--text {
  position: relative;
  z-index: 1;
  flex: 1;

  h1 {
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 34px;
    line-height: 1.2;
    color: #000000;
    margin: 14px 0 8px;

    @media #{$phones, $tablets} {
      font-size: 26px;
      margin-top: 12px;
    }
  }

  p {
    max-width: 760px;
    font-size: 15px;
    line-height: 1.45;
    color: #555555;
    margin: 0;

    @media #{$phones, $tablets} {
      font-size: $font-md;
    }
  }
}

.favorite-connect-header--badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 34px;
  padding: 0 16px;
  border-radius: 28px;
  background: $color-beliruma-1-light;
  border: 1px solid #eeeeee;
  color: $color-beliruma-1;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 13px;
}

.back--button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  min-width: 132px;
  height: 42px;
  border-radius: 999px;
  background: $color-beliruma-1;
  border: 1px solid #eeeeee;
  color: #eeeeee;
  font-family: Poppins-Bold, sans-serif;
  font-size: 14px;
  box-shadow: 0 8px 18px rgba(33, 33, 33, 0.05);

  .back--icon {
    color: #eeeeee;
    font-size: 20px;
  }

  @media #{$phones, $tablets} {
    min-width: 100%;
    height: 42px;
    font-size: 16px;
  }
}
</style>
